<script setup lang="ts">
import { Category } from "~/types"
import type { HomepageCategory } from "./types"
import CategoryItem from './CategoryItem.vue'

const categories: HomepageCategory[] = [
  {
    label: 'Luce',
    cta: 'Scopri di più',
    icon: Category.ELECTRICITY,
    route: 'categoria/energia',
  },
  {
    label: 'Gas',
    cta: 'Scopri di più',
    icon: Category.GAS,
    route: 'categoria/energia',
  },
  {
    label: 'Internet',
    cta: 'Scopri di più',
    icon: Category.TELCO,
    route: 'categoria/telefonia',
  },
]
</script>

<template>
  <div class="relative w-full flex justify-center items-center z-10 px-4">
    <div class="bg-slate-50/95 backdrop-blur-md rounded-[28px] p-6 sm:p-8 shadow-2xl border border-slate-100 max-w-xl w-full flex flex-col items-center gap-6 sm:gap-8">
      <h2 class="text-xl sm:text-2xl text-slate-800 font-extrabold text-center leading-tight">
        Scopri subito le nostre <span class="text-primary">offerte</span>!
      </h2>
      <div class="w-full max-w-[360px] sm:max-w-md">
        <div class="grid grid-cols-3 justify-items-center gap-3 sm:gap-6 w-full">
          <CategoryItem v-for="cat in categories" :key="cat.label" :data="cat" />
        </div>
      </div>
    </div>
  </div>
</template>

